import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Link } from "@mui/material";
import API_URL from "../../config";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import API_BASE_URL from "../../utils/api";

const FacebookPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/facebook/posts?hashtag=MSDigiHub`)
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching FB posts:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <CircularProgress size={24} />;
  }

  if (!posts.length) {
    return <Typography>No Facebook posts found.</Typography>;
  }

  return (
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ color: "#4267b2", fontStyle: "italic", fontWeight: "700" }}
      >
        From Our Facebook Page
      </Typography>
      {posts.map((post, i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            mb: 2,
            p: 1,
            borderBottom: "1px solid #ddd",
            gap: 2,
            alignItems: "flex-start",
          }}
        >
          {post.full_picture && (
            <img
              src={post.full_picture}
              alt=""
              style={{
                width: 60,
                height: 60,
                objectFit: "cover",
                borderRadius: 4,
              }}
            />
          )}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {new Date(post.created_time).toLocaleDateString()}
              </Typography>
              {i === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#ffd700",
                    color: "#fff",
                    borderRadius: "12px",
                    px: 1,
                    py: 0.3,
                    ml: 1,
                    fontSize: "0.75rem",
                    animation: "blink 1.5s infinite",
                    "@keyframes blink": {
                      "0%, 100%": { opacity: 1 },
                      "50%": { opacity: 0.2 },
                    },
                  }}
                >
                  <AutoAwesomeOutlinedIcon
                    sx={{ fontSize: "0.75rem", mr: 0.5 }}
                  />
                  New{" "}
                </Box>
              )}
            </Box>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              {post.message?.slice(0, 100)}...
            </Typography>
            <Link
              href={post.permalink_url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ fontSize: "12px" }}
            >
              View on Facebook
            </Link>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FacebookPosts;
